"use strict";

require("core-js/modules/es.object.from-entries.js");

require("core-js/modules/es.math.hypot.js");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UnrealBloomPass = require("../scripts/UnrealBloomPass");

var THREE = _interopRequireWildcard(require("three"));

var _dForceGraph = _interopRequireDefault(require("3d-force-graph"));

require("./styles/carousel.css");

require("./styles/style.css");

var _domains = _interopRequireDefault(require("../datasets/domains.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Chart3d = function Chart3d() {
  (0, _react.useEffect)(function () {
    var _document$getElementB, _document$getElementB2, _document$getElementB3, _document$getElementB4, _document$getElementB5, _document$getElementB6, _document$getElementB7, _document$getElementB8, _document$getElementB9, _document$getElementB10, _document$getElementB11, _document$getElementB12, _document$getElementB13, _document$getElementB14, _document$getElementB15, _document$getElementB16, _document$getElementB17, _document$getElementB18, _document$getElementB19, _document$getElementB20;

    var gData = JSON.parse(JSON.stringify(_domains["default"]));
    var nodesById = Object.fromEntries(gData.nodes.map(function (node) {
      return [node.id, node];
    }));
    gData.links.forEach(function (link) {
      if (nodesById[link.source].val == 1) {
        nodesById[link.source].childLinks.push(link);
      }
    }); // cross-link node objects

    gData.links.forEach(function (link) {
      var a = nodesById[link.source];
      var b = nodesById[link.target];

      if (a != undefined && b != undefined) {
        !a.neighbors && (a.neighbors = []);
        !b.neighbors && (b.neighbors = []);
        a.neighbors.push(b);
        b.neighbors.push(a);
        !a.links && (a.links = []);
        !b.links && (b.links = []);
        a.links.push(link);
        b.links.push(link);
      }
    });
    var highlightNodes = new Set();
    var highlightLinks = new Set();
    var hoverNode = null;
    var nodecolors = {
      1: '#462BFF',
      2: '#FF800B',
      3: '#00B868',
      4: '#2395FF',
      5: '#00B868',
      21: '#FF4789',
      66: '#8000FF',
      48: '#00B868'
    };

    function threeNodeMesh(node) {
      var baseOpacity = 0.7;
      var minOpacity = 0.1;
      var color = nodecolors[node.val];
      var wireframe;
      var opacity;

      if (!highlightNodes.size || highlightNodes.size == 0) {
        return new THREE.Mesh([new THREE.BoxGeometry(5, 5, 5), new THREE.DodecahedronGeometry(10)][node.val == 48 || node.val == 66 || node.val == 5 || node.val == 21 ? 0 : 1], new THREE.MeshLambertMaterial({
          color: color,
          transparent: true,
          opacity: baseOpacity,
          wireframe: true
        }));
      }

      if (Array.from(highlightNodes).includes(node)) {
        opacity = baseOpacity;
        wireframe = false;
      } else {
        opacity = minOpacity;
        wireframe = true;
      }

      return new THREE.Mesh([new THREE.BoxGeometry(5, 5, 5), new THREE.DodecahedronGeometry(10)][node.val == 48 || node.val == 66 || node.val == 5 || node.val == 21 ? 0 : 1], new THREE.MeshLambertMaterial({
        color: color,
        transparent: true,
        opacity: opacity,
        wireframe: wireframe
      }));
    }

    var Graph = (0, _dForceGraph["default"])({
      controlType: 'orbit'
    })(document.getElementById('3d-graph')).nodeThreeObject(function (node) {
      return threeNodeMesh(node);
    }) //.width(window.innerWidth * 2 / 3.1)
    .height(window.innerHeight - 100).backgroundColor('#02040e').cameraPosition({
      x: 0,
      y: 600,
      z: 1200
    }, {
      x: 0,
      y: 0,
      z: 0
    }).linkColor(function () {
      return 'rgba(255,255,255,0.2)';
    }).linkDirectionalArrowLength(function (link) {
      return link.type == "sync" ? 3.5 : 0;
    }).linkDirectionalArrowRelPos(function (link) {
      return link.type == "sync" ? 0.99 : 0;
    }).linkWidth(function (link) {
      return highlightLinks.has(link) ? 1 : link.type == "sync" ? 0.5 : 0.1;
    }).linkOpacity(0.8).linkDirectionalParticles(function (link) {
      return link.type == "async" ? 5 : 0;
    }).linkDirectionalParticleWidth(0.8).linkDirectionalParticleSpeed(0.01).linkCurvature(function (link) {
      return link.type == "sync" ? 0.5 : 0;
    }).linkCurveRotation(0).nodeLabel('name').onNodeClick(function (node) {
      highlight(''); // no state change

      if (!node && !highlightNodes.size || node && hoverNode === node) return;
      highlightNodes.forEach(function (hn) {
        return hn.__threeObj.material.wireframe = !hn.__threeObj.material.wireframe;
      });
      highlightNodes.clear();
      highlightLinks.clear();

      if (node) {
        highlightNodes.add(node);

        if (node.neighbors != undefined) {
          node.neighbors.forEach(function (neighbor) {
            return highlightNodes.add(neighbor);
          });
        }

        if (node.links != undefined) {
          node.links.forEach(function (link) {
            return highlightLinks.add(link);
          });
        }
      }

      hoverNode = node || null;
      updateHighlight();
      highlightNodes.forEach(function (hn) {
        return hn.__threeObj.material.wireframe = !hn.__threeObj.material.wireframe;
      });
    }).onNodeHover(function (node) {}).onLinkHover(function (link) {}).graphData(gData);
    Graph.d3Force('link').distance(function (link) {
      return link.type == "inner" ? -10 : 100;
    }); /////////////////////////////////////////////////////////////////
    // Elements Glow
    ////////////////////////////////////////////////////////////////

    var bloomPass = new _UnrealBloomPass.UnrealBloomPass();
    bloomPass.strength = 1.3;
    bloomPass.radius = 0.7;
    bloomPass.threshold = 0.1;
    Graph.postProcessingComposer().addPass(bloomPass);
    debugger; ////////////////////////////////////////////////////////////////////////////
    // Estructuring de blueprint in levels                                    //
    ////////////////////////////////////////////////////////////////////////////

    var appsNodes = Object.entries(nodesById).map(function (n) {
      return n;
    }).forEach(function (element) {
      if (element.val == 1) {
        // Platform Domains
        element.fy = 0;
      }

      if (element.val == 2) {
        // Bank's systems
        element.fy = -200;
      }

      if (element.val == 3) {
        // Gateways
        element.fy = 100;
      }

      if (element.val == 4) {
        // Front apps
        element.fy = 200;
      }

      if (element.val == 66 || element.val == 48) {
        // External event processors and Integration Layer
        element.fy = -100;
      }

      if (element.val == 5) {
        // Domain Integrations event processors
        element.fy = -25;
      }

      if (element.val == 21) {
        // REST API
        element.fy = 25;
      }
    }); // // Drawing levels mesh
    // // Apps level
    // const appplaneGeometry = new THREE.PlaneGeometry(800, 800, 50, 50);
    // const appplaneMaterial = new THREE.MeshLambertMaterial({
    //     color: 0x89faef,
    //     side: THREE.DoubleSide,
    //     wireframe: true,
    //     transparent: true,
    //     opacity: 0.05
    // });
    // const appmesh = new THREE.Mesh(appplaneGeometry, appplaneMaterial);
    // appmesh.position.set(0, 210, 0);
    // appmesh.rotation.set(0.5 * Math.PI, 0, 0);
    // Graph.scene().add(appmesh);
    // // Domains level
    // const domainplaneGeometry = new THREE.PlaneGeometry(800, 800, 50, 50);
    // const domainplaneMaterial = new THREE.MeshLambertMaterial({
    //     color: 0xfad189,
    //     side: THREE.DoubleSide,
    //     wireframe: true,
    //     transparent: true,
    //     opacity: 0.05
    // });
    // const domainmesh = new THREE.Mesh(domainplaneGeometry, domainplaneMaterial);
    // domainmesh.position.set(0, -10, 0);
    // domainmesh.rotation.set(0.5 * Math.PI, 0, 0);
    // Graph.scene().add(domainmesh);
    // // Bank level
    // const bankplaneGeometry = new THREE.PlaneGeometry(800, 800, 50, 50);
    // const bankplaneMaterial = new THREE.MeshLambertMaterial({
    //     color: 0xfa89d1,
    //     side: THREE.DoubleSide,
    //     wireframe: true,
    //     transparent: true,
    //     opacity: 0.05
    // });
    // const bankmesh = new THREE.Mesh(bankplaneGeometry, bankplaneMaterial);
    // bankmesh.position.set(0, -210, 0);
    // bankmesh.rotation.set(0.5 * Math.PI, 0, 0);
    // Graph.scene().add(bankmesh);

    function aimNode(nodeId) {
      var node = nodesById[nodeId];
      var distance = 500;
      var distRatio = 1 + distance / Math.hypot(node.x, node.y, node.z);
      Graph.cameraPosition({
        x: node.x * distRatio,
        y: node.y * distRatio / 1.5,
        z: node.z * distRatio
      }, // new position
      node, // lookAt ({ x, y, z })
      3000 // ms transition duration
      );
    } ///////////////////////////////////////////////////////////////////////////////////////////
    ////                                 Hexagons panel                                    ////
    ///////////////////////////////////////////////////////////////////////////////////////////


    var hexs = document.getElementsByClassName("hexagon");
    Array.prototype.forEach.call(hexs, function (hex) {
      hex.addEventListener('click', function () {
        Array.from(document.getElementsByClassName('selected')).forEach(function (el) {
          el.classList.remove('selected');
        });
        hex.classList.add('selected');
        var nodeId = hex.id.split('nav-')[1]; // Aim at node from outside it

        aimNode(nodeId);
      });
    });
    var sliderKeys = {
      "sl-fmc": ["nav-products", "nav-customers", "nav-customersRelations", "nav-historyRecords", "nav-cta", "nav-flows", "nav-documentManager", "nav-users", "nav-portfolio"],
      "sl-mc": ["nav-customers", "nav-cta", "nav-documentManager", "nav-users", "nav-portfolio"],
      "sl-flw": ["nav-products", "nav-customers", "nav-historyRecords", "nav-cta", "nav-flows", "nav-documentManager", "nav-users", "nav-offers", "nav-pricing", "nav-risk-compliance"],
      "sl-spa": ["nav-customers", "nav-historyRecords", "nav-cta", "nav-flows", "nav-documentManager", "nav-users", "nav-calendar"],
      "sl-mr": ["nav-a1-campaigns", "nav-a1-analytics", "nav-products", "nav-customers", "nav-historyRecords", "nav-cta", "nav-users", "nav-portfolio"],
      "sl-wlt": ["nav-products", "nav-customers", "nav-historyRecords", "nav-cta", "nav-flows", "nav-documentManager", "nav-customersUsers"]
    };
    var slides = document.getElementsByClassName("slideImage");
    Array.prototype.forEach.call(slides, function (slide) {
      slide.addEventListener('click', function () {
        Array.from(document.getElementsByClassName('selected')).forEach(function (el) {
          el.classList.remove('selected');
        });
        sliderKeys[slide.id].forEach(function (hex) {
          document.getElementById(hex).classList.add('selected');
        });
      });
    }); //Nodes lightning

    function updateHighlight() {
      // trigger update of highlighted objects in scene
      Graph.linkWidth(Graph.linkWidth()).linkDirectionalParticles(Graph.linkDirectionalParticles());
    }

    function highlight() {
      for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
        nodes[_key] = arguments[_key];
      } // turns off current highlights


      highlightNodes.forEach(function (hn) {
        return hn.__threeObj.material.wireframe = !hn.__threeObj.material.wireframe;
      });
      highlightNodes.clear();
      highlightLinks.clear();
      gData.nodes.filter(function (item) {
        return nodes.includes(item.id);
      }).forEach(function (node) {
        if (node && !Array.from(highlightNodes).includes(node)) {
          highlightNodes.add(node);

          if (node.neighbors != undefined) {
            node.neighbors.forEach(function (neighbor) {
              return highlightNodes.add(neighbor);
            });
          }

          if (node.links != undefined) {
            node.links.forEach(function (link) {
              return highlightLinks.add(link);
            });
          }
        }
      });
      updateHighlight();
      highlightNodes.forEach(function (hn) {
        return hn.__threeObj.material.wireframe = !hn.__threeObj.material.wireframe;
      });
      Graph.nodeThreeObject(function (node) {
        return threeNodeMesh(node);
      });
    } /////////////////////////////////////////////////////////////////////////////
    //                          Start presenting                             ////
    /////////////////////////////////////////////////////////////////////////////


    Graph.cameraPosition({
      x: 0,
      y: 25,
      z: 600
    }, {
      x: 0,
      y: 0,
      z: 0
    }, 3000);
    var controls = Graph.controls();
    controls.minDistance = 200;
    controls.maxDistance = 1500; /////////////////////////////////////////////////////////////////////////////
    //                          footer actions                               ////
    /////////////////////////////////////////////////////////////////////////////

    var baseCamera = Graph.camera().clone();
    (_document$getElementB = document.getElementById('f-platform')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.addEventListener('click', function () {
      highlight('');
      Graph.cameraPosition({
        x: 0,
        y: 25,
        z: 600
      }, {
        x: 0,
        y: 0,
        z: 0
      }, 2000);
    });
    (_document$getElementB2 = document.getElementById('f-openbanking')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.addEventListener('click', function () {
      highlight('productSystems', 'customerSystems', 'historyRecords', 'customersRelations', 'products', 'customers', 'documentationSystems');
      aimNode('products-int');
    });
    (_document$getElementB3 = document.getElementById('f-analytics')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.addEventListener('click', function () {
      highlight('a1-analytics', 'a1-analyticsGateway', 'a1-analyticsWebApp', 'products', 'customers', 'productSystems', 'customerSystems');
      aimNode('a1-analyticsWebApp');
    });
    (_document$getElementB4 = document.getElementById('f-commercialsystematics')) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.addEventListener('click', function () {
      highlight('productSystems', 'a1-campaigns', 'calendar', 'customerSystems', 'myResults', 'cta', 'spaGateway', 'portfolio', 'products', 'customers', 'users', 'nowGateway', 'nowApp');
      aimNode('spaGateway');
    });
    (_document$getElementB5 = document.getElementById('f-digitalmarketing')) === null || _document$getElementB5 === void 0 ? void 0 : _document$getElementB5.addEventListener('click', function () {
      highlight('calendar', 'portfolio', 'documentManager', 'documentationSystems', 'products', 'customers', 'users', 'nowGateway', 'nowApp');
      aimNode('customers');
    });
    (_document$getElementB6 = document.getElementById('f-mobilebanking')) === null || _document$getElementB6 === void 0 ? void 0 : _document$getElementB6.addEventListener('click', function () {
      highlight('mobileApp', 'customerSystems', 'customersUsers', 'cta', 'historyRecords', 'portfolio', 'products', 'customers', 'mobileGateway');
      aimNode('mobileApp');
    });
    (_document$getElementB7 = document.getElementById('f-onlinebanking')) === null || _document$getElementB7 === void 0 ? void 0 : _document$getElementB7.addEventListener('click', function () {
      highlight('nowGateway', 'customerSystems', 'customersUsers', 'cta', 'historyRecords', 'products', 'customers');
      aimNode('customerSystems');
    });
    (_document$getElementB8 = document.getElementById('f-ai')) === null || _document$getElementB8 === void 0 ? void 0 : _document$getElementB8.addEventListener('click', function () {
      highlight('a1-analytics', 'a1-analyticsGateway', 'a1-analyticsWebApp');
      aimNode('a1-analytics');
    });
    (_document$getElementB9 = document.getElementById('f-realtimedecisions')) === null || _document$getElementB9 === void 0 ? void 0 : _document$getElementB9.addEventListener('click', function () {
      highlight('a1-campaigns', 'a1-analytics', 'cta', 'a1-analyticsGateway', 'a1-campaignsGateway', 'a1-analyticsWebApp', 'a1-campaignsWebApp');
      aimNode('a1-campaigns');
    });
    (_document$getElementB10 = document.getElementById('f-omnichannelsolution')) === null || _document$getElementB10 === void 0 ? void 0 : _document$getElementB10.addEventListener('click', function () {
      highlight('customers', 'products', 'customersRelations', 'portfolio', 'historyRecords', 'flows', 'offers', 'calendar', 'dashboard', 'customersUsers', 'a1-analytics', 'documentManager', 'users', 'pricing', 'cta', 'a1-campaigns', 'risk-compliance', 'myResults', 'insights');
      Graph.cameraPosition({
        x: 0,
        y: 400,
        z: 600
      }, {
        x: 0,
        y: 0,
        z: 0
      }, 2000);
    });
    (_document$getElementB11 = document.getElementById('f-incentives')) === null || _document$getElementB11 === void 0 ? void 0 : _document$getElementB11.addEventListener('click', function () {
      highlight('productSystems', 'customerSystems', 'myResults', 'portfolio', 'products', 'customers', 'users', 'nowGateway', 'nowApp', 'spaGateway');
      aimNode('myResults');
    });
    (_document$getElementB12 = document.getElementById('f-commercialPipeline')) === null || _document$getElementB12 === void 0 ? void 0 : _document$getElementB12.addEventListener('click', function () {
      highlight('calendar', 'flows', 'myResults', 'portfolio', 'documentManager', 'documentationSystems', 'products', 'customers', 'users', 'nowGateway', 'nowApp');
      aimNode('flows');
    });
    (_document$getElementB13 = document.getElementById('f-digitalOnboarding')) === null || _document$getElementB13 === void 0 ? void 0 : _document$getElementB13.addEventListener('click', function () {
      highlight('mobileApp', 'customerSystems', 'customersUsers', 'flows', 'historyRecords', 'products', 'productsSystems', 'customers', 'mobileGateway');
      aimNode('OBWalletApp');
    });
    (_document$getElementB14 = document.getElementById('f-crm')) === null || _document$getElementB14 === void 0 ? void 0 : _document$getElementB14.addEventListener('click', function () {
      highlight('productSystems', 'customerSystems', 'calendarSystems', 'identitySystems', 'customersRelations', 'historyRecords', 'portfolio', 'documentManager', 'documentationSystems', 'products', 'customers', 'users', 'nowGateway', 'nowApp');
      aimNode('customers');
    });
    (_document$getElementB15 = document.getElementById('f-wallet')) === null || _document$getElementB15 === void 0 ? void 0 : _document$getElementB15.addEventListener('click', function () {
      highlight('productSystems', 'customerSystems', 'calendarSystems', 'identitySystems', 'historyRecords', 'documentationSystems', 'products', 'customers', 'customersUsers', 'mobileGateway', 'mobileApp');
      aimNode('mobileGateway');
    });
    (_document$getElementB16 = document.getElementById('f-bpm')) === null || _document$getElementB16 === void 0 ? void 0 : _document$getElementB16.addEventListener('click', function () {
      highlight('productSystems', 'customerSystems', 'documentationSystems', 'products', 'customers', 'nowGateway', 'nowApp', 'flows', 'documentManager');
      aimNode('flows-intProc');
    });
    (_document$getElementB17 = document.getElementById('f-cint')) === null || _document$getElementB17 === void 0 ? void 0 : _document$getElementB17.addEventListener('click', function () {
      highlight('productSystems', 'customerSystems', 'calendarSystems', 'identitySystems', 'documentationSystems');
      aimNode('products-int');
    });
    (_document$getElementB18 = document.getElementById('f-camp')) === null || _document$getElementB18 === void 0 ? void 0 : _document$getElementB18.addEventListener('click', function () {
      highlight('a1-campaigns', 'a1-analytics', 'cta', 'a1-analyticsGateway', 'a1-campaignsGateway', 'a1-analyticsWebApp', 'a1-campaignsWebApp', 'productSystems', 'customerSystems');
      aimNode('a1-campaignsWebApp');
    });
    (_document$getElementB19 = document.getElementById('f-users')) === null || _document$getElementB19 === void 0 ? void 0 : _document$getElementB19.addEventListener('click', function () {
      highlight('users', 'identitySystems', 'a1-analyticsGateway', 'a1-campaignsGateway', 'nowGateway');
      aimNode('users-int');
    });
    (_document$getElementB20 = document.getElementById('f-domains')) === null || _document$getElementB20 === void 0 ? void 0 : _document$getElementB20.addEventListener('click', function () {
      highlight('customers', 'products', 'customersRelations', 'portfolio', 'historyRecords', 'flows', 'offers', 'calendar', 'dashboard', 'customersUsers', 'a1-analytics', 'documentManager', 'users', 'pricing', 'cta', 'a1-campaigns', 'risk-compliance', 'myResults', 'insights');
      Graph.cameraPosition({
        x: 0,
        y: 400,
        z: 600
      }, {
        x: 0,
        y: 0,
        z: 0
      }, 2000);
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "three-chart-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "3d-graph"
  }));
};

var _default = Chart3d;
exports["default"] = _default;